import React from 'react';
import { Controller } from 'react-hook-form';
import {
  Multiselect
} from 'src/components/index';
import {
  sortGroupOptions,
  DEFAULT_ALL_TEAM_MEMBERS_GROUPS_OPTION
} from 'src/utils/groupUtils';
import COMMON_CONSTANTS from 'common/commonConstants';

const { DEFAULT_ALL_TEAM_MEMBERS_GROUPS_ID } = COMMON_CONSTANTS;

const GroupMultiSelect = ({
  formData,
  disabled,
  placeholder,
  variant,
  multiSelectSelectedItemClasses
}) => {
  const {
    watch,
    control,
    setValue
  } = formData;

  const { groups } = watch();

  const handleCheckAllTeamMembersOption = () => {
    const checkedAllTeamMembersOption = {
      ...DEFAULT_ALL_TEAM_MEMBERS_GROUPS_OPTION,
      checked: true
    };
    const newUncheckedOptions = groups
      .filter((g) => g.id !== DEFAULT_ALL_TEAM_MEMBERS_GROUPS_ID)
      .map((g) => ({ ...g, checked: false }));
    const sortedOptions = sortGroupOptions([
      checkedAllTeamMembersOption,
      ...newUncheckedOptions
    ]);
    setValue('groups', sortedOptions);
  };

  const removeGroup = (groupObj) => {
    if (groupObj.id === DEFAULT_ALL_TEAM_MEMBERS_GROUPS_ID) {
      return;
    }
    const allGroupsAreBeingUnchecked = groups
      .filter((g) => g.id !== groupObj.id)
      .every((g) => !g.checked);

    // check "All Team Members" option if all other options are unchecked
    if (allGroupsAreBeingUnchecked) {
      handleCheckAllTeamMembersOption();
      return;
    }
    const uncheckedGroup = { ...groupObj, checked: false };
    const allOtherGroups = groups.filter(
      (group) => group.id !== uncheckedGroup.id
    );
    const sortedOptions = sortGroupOptions([
      uncheckedGroup,
      ...allOtherGroups
    ]);
    setValue('groups', sortedOptions);
  };

  const addGroup = (groupObj) => {
    const isCheckingAllTeamMembersOption = groupObj.id === DEFAULT_ALL_TEAM_MEMBERS_GROUPS_ID;

    // check "All Team Members" option and uncheck all other options
    if (isCheckingAllTeamMembersOption) {
      handleCheckAllTeamMembersOption();
      return;
    }

    const checkedGroup = { ...groupObj, checked: true };
    const allOtherGroups = groups.filter(
      (group) => group.id !== checkedGroup.id && group.id !== DEFAULT_ALL_TEAM_MEMBERS_GROUPS_ID
    );
    const currentCheckedGroups = allOtherGroups.filter(
      (group) => group.checked
    );
    const currentUncheckedGroups = allOtherGroups.filter(
      (group) => !group.checked
    );
    const uncheckedAllTeamMembersOption = {
      ...DEFAULT_ALL_TEAM_MEMBERS_GROUPS_OPTION,
      checked: false
    };

    const newCheckedGroups = [checkedGroup, ...currentCheckedGroups];
    const newUncheckedGroups = [
      uncheckedAllTeamMembersOption,
      ...currentUncheckedGroups
    ];
    const sortedOptions = sortGroupOptions([
      ...newCheckedGroups,
      ...newUncheckedGroups
    ]);
    setValue('groups', sortedOptions);
  };

  const toggleGroup = (group) => {
    const isUnchecking = group.checked;

    if (isUnchecking) {
      removeGroup(group);
      return;
    }
    addGroup(group);
  };

  return (
    <Controller
      name='groups'
      control={control}
      render={() => (
        <div className='w-full max-w-34rem inline-block align-top'>
          <Multiselect
            disabled={disabled}
            multiSelectSelectedItemClasses={multiSelectSelectedItemClasses}
            options={groups}
            placeholder={placeholder}
            variant={variant}
            multiselect
            onChange={(option, type) => {
              if (type === 'select') {
                return toggleGroup(option);
              }
              if (type === 'remove') {
                return removeGroup(option);
              }
            }}
          />
        </div>
      )}
    />
  );
};

export default GroupMultiSelect;
